import React, { useMemo } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../layout";
import Counter from "./counter";

export function DisplayCounter(props) {
  return <Counter {...props} />;
}
